import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainChatComponent } from './components/main-chat/main-chat.component';
import { ChatRoomEntryComponent } from './components/chat-room-entry/chat-room-entry.component';
import { ChatRoomComponent } from './components/chat-room/chat-room.component';
import { ChatMessageComponent } from './components/chat-message/chat-message.component';
import { ChatRoomListComponent } from './components/chat-room-list/chat-room-list.component';
import {DialogModule} from 'primeng/dialog';
import {WidgetLibraryModule} from '../_widget-library/widget-library.module';
import {AvatarGroupModule} from 'primeng/avatargroup';
import {AvatarModule} from 'primeng/avatar';
import {FormsModule} from '@angular/forms';
import {TooltipModule} from 'primeng/tooltip';



@NgModule({
    declarations: [
        MainChatComponent,
        ChatRoomEntryComponent,
        ChatRoomComponent,
        ChatMessageComponent,
        ChatRoomListComponent
    ],
    exports: [
        MainChatComponent
    ],
    imports: [
        CommonModule,
        DialogModule,
        WidgetLibraryModule,
        AvatarGroupModule,
        AvatarModule,
        FormsModule,
        TooltipModule
    ]
})
export class ChatModule { }
